import { Button, TextField } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { State } from '../types/state'
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import { useNavigate } from 'react-router'
import { RefreshActions } from '../state/refresh'
import { useRequests } from '../requests/useRequests'
import { Role } from '../types/user'

export const ProfileContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(3)
}))

const ButtonsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  marginTop: theme.spacing(1)
}))

const Profile = (): JSX.Element => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const requestMaker = useRequests()
  const [isEmailCodeVisible, setIsEmailCodeVisible] = useState(false)
  const [emailConfirmationCode, setEmailConfirmationCode] = useState<string>('')
  const [emailConfirmationCodeError, setEmailConfirmationCodeError] = useState<
  string | null
  >(null)
  const userState = useSelector((state: State) => state.user)

  const handleSendEmailCode = async (): Promise<void> => {
    setIsEmailCodeVisible(true)
    await requestMaker.sendEmailCode()
  }

  const handleActivateEmail = async (): Promise<void> => {
    try {
      await requestMaker.activateEmail(emailConfirmationCode)
      setIsEmailCodeVisible(false)
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Succesfully activate email'
        })
      )
      dispatch(RefreshActions.refreshUserState())
    } catch (e) {
      setEmailConfirmationCodeError('Bad confirmation code')
    }
  }

  return (
    <div>
      <ProfileContainer>
        <Avatar alt='User Name' sx={{ width: 50, height: 50, marginBottom: 2 }}>
          {userState.username?.[0]}
        </Avatar>
        <Typography variant='h5' gutterBottom>
          {`${userState.username ?? ''} - ${userState.role ?? ''}`}
        </Typography>
        {userState.firstName !== null && userState.lastName !== null && (
          <Typography variant='h6' gutterBottom>
            {`${userState.firstName} ${userState.lastName}`}
          </Typography>
        )}
        <ButtonsContainer>
          {(userState.role === Role.SUPERADMIN ||
            userState.role === Role.TEACHER) && (
              <Button
                variant='contained'
                color='primary'
                onClick={() => navigate('/user-details')}
              >
                Edit User Details
              </Button>
          )}
        </ButtonsContainer>
        <Button
          variant='outlined'
          color='primary'
          style={{ marginTop: '1vh' }}
          onClick={() => navigate('/change-password')}
        >
          Change password
        </Button>
        <p>
          <strong>{userState.email}</strong>{' '}
          {userState.isEmailConfirmed && 'confirmed'}
          {!userState.isEmailConfirmed && 'not confirmed'}
        </p>
        {!userState.isEmailConfirmed && (
          <Button
            onClick={() => {
              void handleSendEmailCode()
            }}
            variant='outlined'
          >
            Send code
          </Button>
        )}
        {isEmailCodeVisible && (
          <TextField
            label='E-mail code'
            variant='filled'
            error={emailConfirmationCodeError !== null}
            helperText={emailConfirmationCodeError}
            id='filled-error'
            value={emailConfirmationCode}
            onChange={e => setEmailConfirmationCode(e.target.value)}
            style={{ margin: '1vw' }}
          />
        )}
        {isEmailCodeVisible && (
          <Button
            onClick={() => {
              void handleActivateEmail()
            }}
            variant='outlined'
          >
            Activate email
          </Button>
        )}
      </ProfileContainer>
    </div>
  )
}

export default Profile
